"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormGroup;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../headline-lockup/index.js"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _FormGroupField = _interopRequireDefault(require("./FormGroupField"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FormGroupSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "FormGroupSection",
  class: "pl-f1c9j9ys"
});
const FormContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FormContainer",
  class: "pl-f1xqd02f"
});
const GroupForm = /*#__PURE__*/(0, _react2.styled)("form")({
  name: "GroupForm",
  class: "pl-g1hvc76g"
});
const FormError = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FormError",
  class: "pl-f1lasztu"
});

/**
 * FormGroup component.
 * @module FormGroup
 *
 * @param {Object} props React Props
 * @param {string} props.id The component's id
 * @param {string} props._name The input field's name
 * @param {string} props.recaptcha The recaptcha configuration 'off' or 'v2' ('v3' - not implemented yet)
 * @param {string} props.heading The forms heading
 * @param {boolean} props.required Whether input field is required
 * @param {string} props.description The form's sub heading text
 * @param {string} props.formErrorText The form's error text
 * @param {string} props.submitText The form's submit button text
 * @param {string} props.nextPage The path to the form's next page
 * @param {string} props.ajaxUrl The form's submit link
 * @param {string} props.width The option to control the forms width in its container
 * @param {Array} [props.fields] The forms fields
 * @returns {React.ReactElement} FormGroup component
 * @public
 */

function FormGroup({
  formErrorText,
  submitText,
  nextPage,
  fields = [],
  ajaxUrl,
  width = 'full',
  formDisclaimer,
  id,
  _name,
  recaptchaSiteKey,
  onError,
  onSubmit,
  onSuccess,
  recaptcha = 'v2',
  ...headlineProps
}) {
  const initialValues = fields.reduce((obj, {
    name,
    value
  }) => ({
    ...obj,
    [name]: value
  }), {});
  const validFields = fields.reduce((obj, curr) => ({
    ...obj,
    [curr.name]: !curr.required
  }), {});
  const [formError, setFormError] = (0, _react.useState)(false);
  const [reCaptchaResponse, setReCaptchaResponse] = (0, _react.useState)('');
  const [formBusy, setFormBusy] = (0, _react.useState)(false);
  const [formValidation, setFormValidation] = (0, _react.useState)({
    ...validFields
  });
  const [formValues, setFormValues] = (0, _react.useState)(initialValues);
  const [formValid, setFormValid] = (0, _react.useState)(false);
  const reCaptchaHandlers = {
    onChange: e => {
      setReCaptchaResponse(e);
      setFormError(false);
    },
    onError: () => {
      setReCaptchaResponse(false);
      setFormError(true);
    },
    onExpired: () => {
      setReCaptchaResponse(false);
      setFormError(false);
    }
  };
  const updateValidation = ({
    name,
    valid
  }) => {
    const validation = {
      ...formValidation,
      [name]: valid
    };
    setFormValidation(validation);
    setFormValid(Object.values(validation).every(val => val === true));
  };
  const handleChange = ({
    value,
    name,
    valid
  }) => {
    if (formValues[name] !== value) {
      setFormValues({
        ...formValues,
        [name]: value
      });
      const field = fields.find(f => f.name === name);
      if (field?.validate || typeof valid === 'boolean') {
        const validateResult = field?.validate ? field.validate(value) : valid;
        updateValidation({
          name,
          valid: validateResult
        });
      }
    }
  };
  const handleValidation = ({
    target
  }) => {
    const {
      value,
      name
    } = target;
    if (!fields.map(({
      name: fieldName
    }) => fieldName).includes(name)) {
      return;
    }
    const valid = value?.length > 0 ? target?.checkValidity() : validFields[name];
    updateValidation({
      name,
      valid
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (formBusy) return;
    setFormBusy(true);
    const data = {
      ...formValues,
      'g-recaptcha-response': reCaptchaResponse
    };
    const {
      sendRequest = true
    } = onSubmit && onSubmit(data) || {};
    if (sendRequest) {
      fetch(ajaxUrl.Value, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(res => {
        if (res.ok) {
          if (onSuccess) {
            onSuccess(data);
          } else {
            global.location = nextPage.startsWith('https://') ? nextPage : global.location.origin + nextPage;
          }
        } else {
          setFormError(true);
          onError();
        }
        setFormBusy(false);
      });
    } else {
      onSuccess(data);
    }
  };
  return /*#__PURE__*/_react.default.createElement(FormGroupSection, {
    className: "form-group-section",
    padding: "medium",
    dataCy: "form-group-section",
    _name: _name,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    headlineTag: "h2",
    headlineSize: "h2",
    textAlign: "center"
  }, headlineProps)), /*#__PURE__*/_react.default.createElement(FormContainer, null, /*#__PURE__*/_react.default.createElement(GroupForm, {
    onSubmit: handleSubmit,
    onChange: handleValidation,
    onBlur: handleValidation
  }, fields && fields.map((field, i) => /*#__PURE__*/_react.default.createElement(_FormGroupField.default, (0, _extends2.default)({}, field, {
    id: `${field?.id}-${i}`,
    key: i,
    onChange: handleChange
  }))), recaptcha === 'v2' && /*#__PURE__*/_react.default.createElement(_FormGroupField.default, (0, _extends2.default)({
    type: "recaptcha"
  }, reCaptchaHandlers, {
    sitekey: recaptchaSiteKey
  })), /*#__PURE__*/_react.default.createElement(_FormGroupField.default, {
    width: width,
    label: "submit button",
    type: "submit",
    name: submitText,
    disabled: formBusy || !formValid || recaptcha === 'v2' && !reCaptchaResponse
  }), formError && /*#__PURE__*/_react.default.createElement(FormError, null, formErrorText))), formDisclaimer && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "paragraph",
    size: -2,
    dataCy: "form-group-disclaimer",
    text: formDisclaimer
  }));
}
FormGroup.propTypes = {
  formErrorText: _propTypes.default.string,
  submitText: _propTypes.default.string,
  nextPage: _propTypes.default.string,
  fields: _propTypes.default.arrayOf(_propTypes.default.shape(_FormGroupField.default.propTypes)),
  ajaxUrl: _propTypes.default.shape({
    Value: _propTypes.default.string
  }),
  width: _propTypes.default.oneOf(['auto', 'full']),
  recaptcha: _propTypes.default.oneOf(['off', 'v2']),
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  formDisclaimer: _propTypes.default.string,
  recaptchaSiteKey: _propTypes.default.string,
  onError: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  onSuccess: _propTypes.default.func
};